// import {
//   collection,
//   serverTimestamp,
//   doc,
//   setDoc,
//   addDoc,
//   Timestamp,
// } from 'firebase/firestore';
// import {
//   ref,
//   uploadBytes,
//   getDownloadURL,
// } from 'firebase/storage';
// import { useState } from 'react';
// import { fireDB, storage } from '../../../../Backend/Firebase/FirebaseConfigData';

// const AddElibraryPage = () => {
//   const [title, setTitle] = useState('');
//   const [author, setAuthor] = useState(''); // ✅ main author
//   const [pdfFile, setPdfFile] = useState(null);
//   const [driveLink, setDriveLink] = useState('');
//   const [blogLink, setBlogLink] = useState('');
//   const [metadata, setMetadata] = useState('');
//   const [dataType, setDataType] = useState('notes');
//   const [loading, setLoading] = useState(false);
//   const [topicId, setTopicId] = useState(null);
//   const [showSubtopics, setShowSubtopics] = useState(false);
//   const [subtopics, setSubtopics] = useState([]);

//   // Subtopic state
//   const [subTitle, setSubTitle] = useState('');
//   const [subAuthor, setSubAuthor] = useState(''); // ✅ subtopic author
//   const [subPdfFile, setSubPdfFile] = useState(null);
//   const [subDriveLink, setSubDriveLink] = useState('');
//   const [subBlogLink, setSubBlogLink] = useState('');
//   const [subMetadata, setSubMetadata] = useState('');
//   const [subDataType, setSubDataType] = useState('notes');

//   const sanitizeTitle = (title) =>
//     title.trim().toLowerCase().replace(/[^a-z0-9\-]/g, '-').replace(/\s+/g, '-');

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!title || (!pdfFile && !driveLink)) {
//       alert('Please provide title and either PDF or Drive link.');
//       return;
//     }

//     setLoading(true);
//     let pdfUrl = '';

//     try {
//       if (pdfFile) {
//         const storageRef = ref(storage, `pdfs/${Date.now()}_${pdfFile.name}`);
//         await uploadBytes(storageRef, pdfFile);
//         pdfUrl = await getDownloadURL(storageRef);
//       }

//       const docId = sanitizeTitle(title);
//       const docRef = doc(fireDB, 'libraryEntries', docId);

//       await setDoc(docRef, {
//         title,
//         author,
//         pdfUrl,
//         driveLink,
//         blogLink,
//         metadata,
//         dataType,
//         fileType: pdfFile?.type || 'drive-link',
//         createdAt: serverTimestamp(),
//       });

//       setTopicId(docId);
//       setShowSubtopics(true);

//       alert('Main topic added!');
//       setTitle('');
//       setAuthor('');
//       setPdfFile(null);
//       setDriveLink('');
//       setBlogLink('');
//       setMetadata('');
//       setDataType('notes');
//     } catch (error) {
//       console.error(error);
//       alert('Failed to add topic');
//     }

//     setLoading(false);
//   };

//   const handleAddSubtopic = async () => {
//     if (!subTitle || (!subPdfFile && !subDriveLink)) {
//       alert('Please fill in required subtopic fields.');
//       return;
//     }

//     setLoading(true);
//     let subPdfUrl = '';

//     try {
//       if (subPdfFile) {
//         const storageRef = ref(
//           storage,
//           `subtopics/${Date.now()}_${subPdfFile.name}`
//         );
//         await uploadBytes(storageRef, subPdfFile);
//         subPdfUrl = await getDownloadURL(storageRef);
//       }

//       const subRef = collection(fireDB, 'libraryEntries', topicId, 'subtopics');

//       const newSub = {
//         title: subTitle,
//         author: subAuthor,
//         pdfUrl: subPdfUrl,
//         driveLink: subDriveLink,
//         blogLink: subBlogLink,
//         metadata: subMetadata,
//         dataType: subDataType,
//         fileType: subPdfFile?.type || 'drive-link',
//         createdAt: serverTimestamp(),
//       };

//       const docRes = await addDoc(subRef, newSub);
//       setSubtopics([...subtopics, { ...newSub, id: docRes.id }]);

//       // Clear fields
//       setSubTitle('');
//       setSubAuthor('');
//       setSubPdfFile(null);
//       setSubDriveLink('');
//       setSubBlogLink('');
//       setSubMetadata('');
//       setSubDataType('notes');
//     } catch (error) {
//       console.error(error);
//       alert('Error adding subtopic');
//     }

//     setLoading(false);
//   };

//   return (
//     <div className="min-h-screen bg-gray-50 p-6">
//       <form
//         onSubmit={handleSubmit}
//         className="bg-white shadow-md rounded-lg p-6 max-w-2xl mx-auto"
//       >
//         <h2 className="text-2xl font-semibold mb-4 text-center">📚 Add Main Topic</h2>

//         {/* Title */}
//         <div className="mb-4">
//           <label className="block mb-1 font-medium">Title</label>
//           <input
//             type="text"
//             value={title}
//             onChange={(e) => setTitle(e.target.value)}
//             className="w-full border rounded px-4 py-2"
//             placeholder="Enter topic title"
//             required
//           />
//         </div>

//         {/* Author */}
//         <div className="mb-4">
//           <label className="block mb-1 font-medium">Author</label>
//           <input
//             type="text"
//             value={author}
//             onChange={(e) => setAuthor(e.target.value)}
//             className="w-full border rounded px-4 py-2"
//             placeholder="Enter author's name"
//           />
//         </div>

//         {/* PDF Upload */}
//         <div className="mb-4">
//           <label className="block mb-1 font-medium">Upload PDF (optional)</label>
//           <input
//             type="file"
//             accept="application/pdf"
//             onChange={(e) => setPdfFile(e.target.files[0])}
//             className="w-full"
//           />
//         </div>

//         {/* Drive Link */}
//         <div className="mb-4">
//           <label className="block mb-1 font-medium">Google Drive Link (optional)</label>
//           <input
//             type="url"
//             value={driveLink}
//             onChange={(e) => setDriveLink(e.target.value)}
//             className="w-full border rounded px-4 py-2"
//             placeholder="https://drive.google.com/..."
//           />
//         </div>

//         {/* Blog Link */}
//         <div className="mb-4">
//           <label className="block mb-1 font-medium">Blog Link</label>
//           <input
//             type="url"
//             value={blogLink}
//             onChange={(e) => setBlogLink(e.target.value)}
//             className="w-full border rounded px-4 py-2"
//             placeholder="https://example.com"
//           />
//         </div>

//         {/* Metadata */}
//         <div className="mb-4">
//           <label className="block mb-1 font-medium">SEO Metadata</label>
//           <textarea
//             value={metadata}
//             onChange={(e) => setMetadata(e.target.value)}
//             className="w-full border rounded px-4 py-2"
//             rows={3}
//           />
//         </div>

//         {/* Data Type */}
//         <div className="mb-4">
//           <label className="block mb-1 font-medium">Type</label>
//           <select
//             value={dataType}
//             onChange={(e) => setDataType(e.target.value)}
//             className="w-full border rounded px-4 py-2"
//           >
//             <option value="notes">Notes</option>
//             <option value="pyqs">PYQs</option>
//             <option value="blog">Blog</option>
//             <option value="tutorial">Tutorial</option>
//           </select>
//         </div>

//         <button
//           type="submit"
//           className="w-full bg-blue-600 text-white py-2 rounded hover:bg-blue-700 transition"
//           disabled={loading}
//         >
//           {loading ? 'Uploading...' : 'Submit Topic'}
//         </button>
//       </form>

//       {/* Subtopics Section */}
//       {showSubtopics && (
//         <div className="bg-white shadow-md rounded-lg p-6 max-w-4xl mx-auto mt-10">
//           <h3 className="text-xl font-semibold mb-4">📑 Add Subtopics</h3>

//           <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//             <input
//               type="text"
//               value={subTitle}
//               onChange={(e) => setSubTitle(e.target.value)}
//               placeholder="Subtopic Title"
//               className="border rounded px-4 py-2"
//             />
//             <input
//               type="text"
//               value={subAuthor}
//               onChange={(e) => setSubAuthor(e.target.value)}
//               placeholder="Subtopic Author"
//               className="border rounded px-4 py-2"
//             />
//             <input
//               type="file"
//               accept="application/pdf"
//               onChange={(e) => setSubPdfFile(e.target.files[0])}
//               className="border rounded px-4 py-2"
//             />
//             <input
//               type="url"
//               value={subDriveLink}
//               onChange={(e) => setSubDriveLink(e.target.value)}
//               placeholder="Google Drive Link"
//               className="border rounded px-4 py-2"
//             />
//             <input
//               type="url"
//               value={subBlogLink}
//               onChange={(e) => setSubBlogLink(e.target.value)}
//               placeholder="Blog Link"
//               className="border rounded px-4 py-2"
//             />
//             <input
//               type="text"
//               value={subMetadata}
//               onChange={(e) => setSubMetadata(e.target.value)}
//               placeholder="Metadata"
//               className="border rounded px-4 py-2 col-span-2"
//             />
//             <select
//               value={subDataType}
//               onChange={(e) => setSubDataType(e.target.value)}
//               className="border rounded px-4 py-2 col-span-2"
//             >
//               <option value="notes">Notes</option>
//               <option value="pyqs">PYQs</option>
//               <option value="blog">Blog</option>
//               <option value="tutorial">Tutorial</option>
//             </select>
//           </div>

//           <button
//             onClick={handleAddSubtopic}
//             className="mt-4 bg-green-600 text-white py-2 px-6 rounded hover:bg-green-700 transition"
//           >
//             ➕ Add Subtopic
//           </button>

//           {/* Subtopics Table */}
//           <div className="mt-6">
//             <h4 className="font-semibold mb-2">📄 Added Subtopics</h4>
//             <table className="w-full table-auto border">
//               <thead>
//                 <tr className="bg-gray-100 text-left">
//                   <th className="p-2 border">Title</th>
//                   <th className="p-2 border">Author</th>
//                   <th className="p-2 border">PDF</th>
//                   <th className="p-2 border">Drive</th>
//                   <th className="p-2 border">Blog</th>
//                   <th className="p-2 border">Type</th>
//                   <th className="p-2 border">Date</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {subtopics.map((sub, idx) => (
//                   <tr key={idx} className="border-t">
//                     <td className="p-2 border">{sub.title}</td>
//                     <td className="p-2 border">{sub.author || '—'}</td>
//                     <td className="p-2 border">
//                       {sub.pdfUrl ? (
//                         <a href={sub.pdfUrl} target="_blank" className="text-blue-600 underline">PDF</a>
//                       ) : (
//                         '—'
//                       )}
//                     </td>
//                     <td className="p-2 border">
//                       {sub.driveLink ? (
//                         <a href={sub.driveLink} target="_blank" className="text-blue-600 underline">Drive</a>
//                       ) : (
//                         '—'
//                       )}
//                     </td>
//                     <td className="p-2 border">
//                       {sub.blogLink ? (
//                         <a href={sub.blogLink} target="_blank" className="text-blue-600 underline">Blog</a>
//                       ) : (
//                         '—'
//                       )}
//                     </td>
//                     <td className="p-2 border">{sub.dataType}</td>
//                     <td className="p-2 border">
//                       {sub.createdAt?.seconds ? new Date(sub.createdAt.seconds * 1000).toLocaleDateString() : '—'}
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default AddElibraryPage;



import { collection, serverTimestamp, doc, setDoc, addDoc } from 'firebase/firestore';
import { useState } from 'react';
import { fireDB } from '../../../../Backend/Firebase/FirebaseConfigData';

const AddElibraryPage = () => {
  const [title, setTitle] = useState('');
  const [author, setAuthor] = useState('');
  const [driveLink, setDriveLink] = useState('');
  const [blogLink, setBlogLink] = useState('');
  const [metadata, setMetadata] = useState('');
  const [dataType, setDataType] = useState('notes');
  const [loading, setLoading] = useState(false);
  const [topicId, setTopicId] = useState<string | null>(null);
  const [showSubtopics, setShowSubtopics] = useState(false);
  const [subtopics, setSubtopics] = useState<any[]>([]);

  // Subtopic state
  const [subTitle, setSubTitle] = useState('');
  const [subAuthor, setSubAuthor] = useState('');
  const [subDriveLink, setSubDriveLink] = useState('');
  const [subBlogLink, setSubBlogLink] = useState('');
  const [subMetadata, setSubMetadata] = useState('');
  const [subDataType, setSubDataType] = useState('notes');

  const sanitizeTitle = (title: string) =>
    title.trim().toLowerCase().replace(/[^a-z0-9\-]/g, '-').replace(/\s+/g, '-');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!title || !driveLink) {
      alert('Please provide title and Drive link.');
      return;
    }

    setLoading(true);

    try {
      const docId = sanitizeTitle(title);
      const docRef = doc(fireDB, 'libraryEntries', docId);

      await setDoc(docRef, {
        title,
        author,
        driveLink,
        blogLink,
        metadata,
        dataType,
        fileType: 'drive-link',
        createdAt: serverTimestamp(),
      });

      setTopicId(docId);
      setShowSubtopics(true);

      alert('Main topic added!');
      setTitle('');
      setAuthor('');
      setDriveLink('');
      setBlogLink('');
      setMetadata('');
      setDataType('notes');
    } catch (error) {
      console.error(error);
      alert('Failed to add topic');
    }

    setLoading(false);
  };

  const handleAddSubtopic = async () => {
    if (!subTitle || !subDriveLink || !topicId) {
      alert('Please fill in required subtopic fields.');
      return;
    }

    setLoading(true);

    try {
      const subRef = collection(fireDB, 'libraryEntries', topicId, 'subtopics');

      const newSub = {
        title: subTitle,
        author: subAuthor,
        driveLink: subDriveLink,
        blogLink: subBlogLink,
        metadata: subMetadata,
        dataType: subDataType,
        fileType: 'drive-link',
        createdAt: serverTimestamp(),
      };

      const docRes = await addDoc(subRef, newSub);
      setSubtopics([...subtopics, { ...newSub, id: docRes.id }]);

      // Clear fields
      setSubTitle('');
      setSubAuthor('');
      setSubDriveLink('');
      setSubBlogLink('');
      setSubMetadata('');
      setSubDataType('notes');
    } catch (error) {
      console.error(error);
      alert('Error adding subtopic');
    }

    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-gray-50 p-6">
      <form
        onSubmit={handleSubmit}
        className="bg-white shadow-md rounded-lg p-6 max-w-2xl mx-auto"
      >
        <h2 className="text-2xl font-semibold mb-4 text-center">📚 Add Main Topic</h2>

        {/* Title */}
        <div className="mb-4">
          <label className="block mb-1 font-medium">Title</label>
          <input
            type="text"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            className="w-full border rounded px-4 py-2"
            placeholder="Enter topic title"
            required
          />
        </div>

        {/* Author */}
        <div className="mb-4">
          <label className="block mb-1 font-medium">Author</label>
          <input
            type="text"
            value={author}
            onChange={(e) => setAuthor(e.target.value)}
            className="w-full border rounded px-4 py-2"
            placeholder="Enter author's name"
          />
        </div>

        {/* Drive Link */}
        <div className="mb-4">
          <label className="block mb-1 font-medium">Google Drive Link</label>
          <input
            type="url"
            value={driveLink}
            onChange={(e) => setDriveLink(e.target.value)}
            className="w-full border rounded px-4 py-2"
            placeholder="https://drive.google.com/..."
            required
          />
        </div>

        {/* Blog Link */}
        <div className="mb-4">
          <label className="block mb-1 font-medium">Blog Link</label>
          <input
            type="url"
            value={blogLink}
            onChange={(e) => setBlogLink(e.target.value)}
            className="w-full border rounded px-4 py-2"
            placeholder="https://example.com"
          />
        </div>

        {/* Metadata */}
        <div className="mb-4">
          <label className="block mb-1 font-medium">SEO Metadata</label>
          <textarea
            value={metadata}
            onChange={(e) => setMetadata(e.target.value)}
            className="w-full border rounded px-4 py-2"
            rows={3}
          />
        </div>

        {/* Data Type */}
        <div className="mb-4">
          <label className="block mb-1 font-medium">Type</label>
          <select
            value={dataType}
            onChange={(e) => setDataType(e.target.value)}
            className="w-full border rounded px-4 py-2"
          >
            <option value="notes">Notes</option>
            <option value="pyqs">PYQs</option>
            <option value="blog">Blog</option>
            <option value="tutorial">Tutorial</option>
          </select>
        </div>

        <button
          type="submit"
          className="w-full bg-blue-600 text-white py-2 rounded hover:bg-blue-700 transition"
          disabled={loading}
        >
          {loading ? 'Saving...' : 'Submit Topic'}
        </button>
      </form>

      {/* Subtopics Section */}
      {showSubtopics && (
        <div className="bg-white shadow-md rounded-lg p-6 max-w-4xl mx-auto mt-10">
          <h3 className="text-xl font-semibold mb-4">📑 Add Subtopics</h3>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <input
              type="text"
              value={subTitle}
              onChange={(e) => setSubTitle(e.target.value)}
              placeholder="Subtopic Title"
              className="border rounded px-4 py-2"
            />
            <input
              type="text"
              value={subAuthor}
              onChange={(e) => setSubAuthor(e.target.value)}
              placeholder="Subtopic Author"
              className="border rounded px-4 py-2"
            />
            <input
              type="url"
              value={subDriveLink}
              onChange={(e) => setSubDriveLink(e.target.value)}
              placeholder="Google Drive Link"
              className="border rounded px-4 py-2"
            />
            <input
              type="url"
              value={subBlogLink}
              onChange={(e) => setSubBlogLink(e.target.value)}
              placeholder="Blog Link"
              className="border rounded px-4 py-2"
            />
            <input
              type="text"
              value={subMetadata}
              onChange={(e) => setSubMetadata(e.target.value)}
              placeholder="Metadata"
              className="border rounded px-4 py-2 col-span-2"
            />
            <select
              value={subDataType}
              onChange={(e) => setSubDataType(e.target.value)}
              className="border rounded px-4 py-2 col-span-2"
            >
              <option value="notes">Notes</option>
              <option value="pyqs">PYQs</option>
              <option value="blog">Blog</option>
              <option value="tutorial">Tutorial</option>
            </select>
          </div>

          <button
            onClick={handleAddSubtopic}
            className="mt-4 bg-green-600 text-white py-2 px-6 rounded hover:bg-green-700 transition"
          >
            ➕ Add Subtopic
          </button>

          {/* Subtopics Table */}
          <div className="mt-6">
            <h4 className="font-semibold mb-2">📄 Added Subtopics</h4>
            <table className="w-full table-auto border">
              <thead>
                <tr className="bg-gray-100 text-left">
                  <th className="p-2 border">Title</th>
                  <th className="p-2 border">Author</th>
                  <th className="p-2 border">Drive</th>
                  <th className="p-2 border">Blog</th>
                  <th className="p-2 border">Type</th>
                  <th className="p-2 border">Date</th>
                </tr>
              </thead>
              <tbody>
                {subtopics.map((sub, idx) => (
                  <tr key={idx} className="border-t">
                    <td className="p-2 border">{sub.title}</td>
                    <td className="p-2 border">{sub.author || '—'}</td>
                    <td className="p-2 border">
                      {sub.driveLink ? (
                        <a href={sub.driveLink} target="_blank" className="text-blue-600 underline">Drive</a>
                      ) : '—'}
                    </td>
                    <td className="p-2 border">
                      {sub.blogLink ? (
                        <a href={sub.blogLink} target="_blank" className="text-blue-600 underline">Blog</a>
                      ) : '—'}
                    </td>
                    <td className="p-2 border">{sub.dataType}</td>
                    <td className="p-2 border">
                      {sub.createdAt?.seconds ? new Date(sub.createdAt.seconds * 1000).toLocaleDateString() : '—'}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};

export default AddElibraryPage;
